/**
 * `mm:ss` clock label (chapter marks, time on air, watched time, transcript timestamps).
 * Pure — no Angular DI — so every academy layer (data/ui/feature) can share one formatter.
 */
export function formatClock(totalSeconds: number): string {
  const safe = Math.max(0, totalSeconds);
  const mm = String(Math.floor(safe / 60)).padStart(2, '0');
  const ss = String(Math.floor(safe % 60)).padStart(2, '0');
  return `${mm}:${ss}`;
}

/**
 * Inverse of `formatClock` — parse a `mm:ss` (or `h:mm:ss`) clock label typed by the
 * producer into total seconds. Returns `null` when the label is malformed, so callers
 * can hold invalid drafts back from the API.
 */
export function parseClock(label: string): number | null {
  const parts = label.trim().split(':');
  if (parts.length < 2 || parts.length > 3) return null;
  if (parts.some((p) => !/^\d{1,2}$/.test(p))) return null;
  const [seconds, minutes, hours] = parts.map(Number).reverse();
  if (seconds > 59 || (parts.length === 3 && minutes > 59)) return null;
  return seconds + minutes * 60 + (hours ?? 0) * 3600;
}
